import { NavLink } from 'react-router-dom';
import { LayoutGrid, Users, Activity, Folder } from 'lucide-react';
import clsx from 'clsx';

const linkClass = ({ isActive }: { isActive: boolean }) => clsx(
  'flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition',
  isActive ? 'bg-zinc-800 text-white' : 'text-zinc-400 hover:bg-zinc-800/60 hover:text-zinc-100',
);

export function Sidebar() {
  return (
    <aside className="flex w-56 shrink-0 flex-col gap-4 border-r border-zinc-800 bg-zinc-900/60 p-4">
      <div className="text-lg font-semibold">Dev Board</div>
      <nav className="flex flex-col gap-1">
        <NavLink to="/" end className={linkClass}>
          <Folder size={16} /> Projects
        </NavLink>
        <NavLink to="/board" className={linkClass}>
          <LayoutGrid size={16} /> Board
        </NavLink>
        <NavLink to="/admin/users" className={linkClass}>
          <Users size={16} /> Users
        </NavLink>
        <NavLink to="/admin/health" className={linkClass}>
          <Activity size={16} /> Health
        </NavLink>
      </nav>
    </aside>
  );
}
